/* ============================================================================
   Bird Bliss — Pin Clicked Product First on Collection Pages
   ----------------------------------------------------------------------------
   Reads ?first=<handle | encoded product URL> (+ optional &variant=<id>) and
   places that product in position 1 of the collection grid.

   Strategy (differs from Den Liu's original on purpose):
   - NEVER clears/rebuilds the grid (no "lonely product" moment, no N+1 fetches,
     no broken product counts).
   - If the product is already in the server-rendered grid -> move it to the
     front. Instant, zero network requests.
   - If not -> fetch its card via /products/<handle>?view=card and prepend it,
     dropping the last card to keep the grid count even.
   - variant= only swaps the card image + link so the ad's colour matches.

   Install: assets/pin-first.js, loaded from main-collection-product-grid.liquid
   (see install-notes.md). Requires templates/product.card.liquid.
   ========================================================================== */
(() => {
  const qp = new URLSearchParams(location.search);
  const raw = (qp.get('first') || '').trim();
  if (!raw) return;

  let handle = '';
  let variantId = (qp.get('variant') || '').trim();

  if (/^https?:/i.test(raw)) {
    // Facebook catalog deep-link form: first=<encoded product URL>
    try {
      const u = new URL(raw);
      const segs = u.pathname.split('/').filter(Boolean);
      const pi = segs.indexOf('products');
      if (pi !== -1 && segs[pi + 1]) handle = segs[pi + 1];
      variantId = variantId || (u.searchParams.get('variant') || '');
    } catch (_) { /* malformed URL — bail quietly */ }
  } else {
    handle = raw.split('/').filter(Boolean).pop() || '';
  }

  handle = handle.toLowerCase();
  if (!handle) return;
  if (!/^\d+$/.test(variantId)) variantId = '';

  const productHandleFromCard = (li) => {
    const a = li.querySelector('a[href*="/products/"]');
    if (!a) return '';
    const path = a.getAttribute('href').split('?')[0];
    const segs = path.split('/').filter(Boolean);
    const pi = segs.indexOf('products');
    return (pi !== -1 && segs[pi + 1] ? segs[pi + 1] : '').toLowerCase();
  };

  const applyVariant = (li) => {
    if (!variantId) return;
    fetch(`/products/${encodeURIComponent(handle)}.js`)
      .then((r) => (r.ok ? r.json() : null))
      .then((prod) => {
        if (!prod) return;
        const v = (prod.variants || []).find((x) => String(x.id) === variantId);
        if (!v || !v.featured_image) return;
        li.querySelectorAll('img').forEach((img) => {
          img.removeAttribute('srcset');
          img.removeAttribute('data-srcset');
          img.src = v.featured_image.src;
        });
        li.querySelectorAll('a[href*="/products/"]').forEach((a) => {
          const u = new URL(a.getAttribute('href'), location.origin);
          u.searchParams.set('variant', variantId);
          a.setAttribute('href', u.pathname + u.search);
        });
      })
      .catch(() => {});
  };

  const run = () => {
    const grid =
      document.getElementById('product-grid') ||
      document.querySelector('ul[id^="product-grid"], .product-grid');
    if (!grid) return;

    const items = [...grid.children].filter((el) => el.tagName === 'LI');
    if (!items.length) return;

    const match = items.find((li) => productHandleFromCard(li) === handle);
    if (match) {
      if (match !== items[0]) grid.prepend(match);
      applyVariant(match);
      return;
    }

    fetch(`/products/${encodeURIComponent(handle)}?view=card`)
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        if (!html.trim()) return;
        const tpl = document.createElement('template');
        tpl.innerHTML = html.trim();
        const li = tpl.content.querySelector('li') || tpl.content.firstElementChild;
        if (!li) return;
        // A 200 is NOT proof we got the right card. Shopify can return the card
        // template rendered with an EMPTY product — Dawn's "Example product title /
        // $19.99" onboarding placeholder. The old code trusted any <li> in a 200, so
        // that placeholder got pinned to slot 1 of a paid ad landing page AND a real
        // selling product was deleted to make room for it. Observed on the live
        // pinned catalog ad 2026-07-20 (Paul's screenshot); not reproducible on
        // demand, so treat it as "can happen" rather than "happens when X".
        // Only trust a card that actually links to the handle we asked for.
        // Anything else -> do nothing, leave a normal collection page.
        if (productHandleFromCard(li) !== handle) return;
        grid.prepend(li);
        items[items.length - 1].remove(); // keep the grid count even
        applyVariant(li);
      })
      .catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
